import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useActionPreviewStyles } from '../useActionPreviewStyles';

export type ActionPreviewHeaderProps = HTMLChakraProps<'div'>;

export const ActionPreviewHeader: React.FC<ActionPreviewHeaderProps> =
  forwardRef<ActionPreviewHeaderProps, 'div'>(({ children, ...props }, ref) => {
    const { header } = useActionPreviewStyles();

    return (
      <chakra.div
        sx={header}
        className="action-preview-header"
        {...props}
        ref={ref}
      >
        {children}
      </chakra.div>
    );
  });
ActionPreviewHeader.displayName = 'ActionPreviewHeader';
